import { useSelector } from 'react-redux';

import { formatNumberAndCents } from '@makemydeal/dr-common-utils';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { DealTabs } from '@makemydeal/dr-shared-types';

import { ReadOnlyLinkRow } from '../../ReadOnlyLinkRow';

export const TaxesRow = () => {
    const taxTotal = useSelector(offerReduxSelectors.getTotalTax);

    return <ReadOnlyLinkRow rowKey="taxes" label="Taxes" value={formatNumberAndCents(taxTotal)} tab={DealTabs.TAXES} />;
};
